import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

import type Survey from 'modules/surveys/store/models/v2/Survey'

import DeleteAuthorAsEditorModal from './DeleteAuthorAsEditorModal'

interface Props {
  userIsAuthor: boolean
  supervisorId: string
  survey: Survey
}

const EditorRightActions = ({ userIsAuthor, supervisorId, survey }: Props) => {
  const [deleteModalOpen, toggleDeleteModal] = useToggle(false)
  const api = apiClient()
  const { running, performAction: onDeleteEditor } = useAsyncAction(async () => {
    await api.del(`/surveys/v2/surveys/${survey.attributes.id}/supervisors`, {
      access_id: supervisorId,
      form_id: survey.attributes.id,
    })
    survey.fetch()
  })

  return (
    <>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.TouchableOption
            title={i18n.t('surveys.form.participants.table.body.edit.delete.survey')}
            disabled={running}
            onClick={userIsAuthor ? toggleDeleteModal(true) : () => onDeleteEditor()}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
      {deleteModalOpen && (
        <DeleteAuthorAsEditorModal
          survey={survey}
          supervisorId={supervisorId}
          onClose={toggleDeleteModal(false)}
        />
      )}
    </>
  )
}

export default observer(EditorRightActions)
